var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.$q.platform.is.mobile)?_c('div',[_c('CvViewMob')],1):_c('div',[_c('CvView')],1)}
var staticRenderFns = []

export { render, staticRenderFns }